import styles from "./index.module.css";
import { PropsWithChildren, ReactNode } from "react";

interface Props {
  loader: ReactNode | undefined;
}

export const LoadingView = ({ loader }: Props & PropsWithChildren) => {
  return <div className={styles.loading}>{loader}</div>;
};
